export default function DemoBanner() {
  if (import.meta.env.VITE_DEMO_MODE !== 'true') return null

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-gold/90 text-white text-center text-xs font-body py-0.5 pointer-events-none">
      DEMO
    </div>
  )
}
